<template>
  <v-row no-gutters class="fill-height">
    <!-- LADO ESQUERDO -->
    <v-col
      cols="12"
      md="6"
      class="auth-side-panel d-flex flex-column align-center justify-center position-relative"
      style="min-height: 100vh"
    >
      <div class="signup-overlay pa-6 text-center">
        <v-avatar size="120" color="white" class="elevation-4 mb-4 logo-avatar">
          <!-- <img>, e não <v-img>: o webpack só resolve "@/assets/..." em <img>.
                 No <v-img> o caminho ia cru e o avatar ficava um círculo vazio. -->
                      <img src="@/assets/salvia_symbol.svg" alt="Salvia" width="72" height="72" />
        </v-avatar>
        <h3 class="brand-title mb-4">Salvia</h3>
        <p class="side-description mb-6">
          Gerencie sua prática médica com eficiência e segurança
        </p>
        <v-btn
          rounded
          outlined
          large
          dark
          @click="backToLoginPage"
          class="px-8 side-cta"
        >
          <v-icon left>mdi-login</v-icon>
          JÁ TENHO CONTA
        </v-btn>
      </div>
    </v-col>

    <!-- LADO DIREITO -->
    <v-col
      cols="12"
      md="6"
      class="pa-6 register-content"
      style="overflow-y: auto; max-height: 100vh"
    >
      <div class="auth-section-header justify-center">
        <v-icon small color="primary" class="mr-2">mdi-account-plus</v-icon>
        <span class="auth-section-title">Criar conta</span>
      </div>

      <div class="text-center mb-6 mt-2">
        <h2 class="auth-title mb-2">Cadastre-se</h2>
        <p class="auth-subtitle">
          Crie sua conta em poucos passos
        </p>
      </div>

      <v-form ref="form" v-model="formValido">
        <!-- SELEÇÃO DE TIPO DE USUÁRIO -->
        <v-card outlined class="register-card mb-6">
          <v-card-title class="register-card-title">
            <v-icon left color="primary" small>mdi-account-cog</v-icon>
            Tipo de conta
          </v-card-title>
          <v-divider />
          <v-card-text class="pt-4">
            <v-radio-group
              v-model="userType"
              class="mt-0"
              :rules="[(v) => !!v || 'Selecione o tipo de conta']"
            >
              <v-radio
                label="Profissional de Saúde"
                value="doctor"
                color="primary"
              />
              <v-radio label="Assistente" value="assistant" color="primary" />
            </v-radio-group>
            <v-alert
              v-if="!userType"
              type="info"
              text
              dense
              rounded
              class="register-alert mt-2"
            >
              Selecione o tipo de conta para continuar o cadastro.
            </v-alert>
          </v-card-text>
        </v-card>

        <!-- DADOS DO USUÁRIO -->
        <v-expand-transition>
          <div v-if="userType">
            <!-- DADOS DO USUÁRIO -->
            <v-card outlined class="register-card mb-6">
              <v-card-title class="register-card-title">
                <v-icon left color="primary" small>mdi-account</v-icon>
                {{
                  userType === "assistant"
                    ? "Dados do Assistente"
                    : userType === "doctor"
                    ? "Dados do Profissional de Saúde"
                    : "Dados do Usuário"
                }}
              </v-card-title>
              <v-divider />
              <v-card-text class="pt-4">
                <v-text-field
                  v-model="userData.name"
                  label="Nome completo"
                  prepend-inner-icon="mdi-account-outline"
                  outlined
                  color="primary"
                  :rules="[
                    (v) => !!v || 'Nome é obrigatório',
                    (v) =>
                      v.length <= 255 ||
                      'Nome deve ter no máximo 255 caracteres',
                  ]"
                  class="mb-3"
                  clearable
                />

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.email"
                      label="Email"
                      prepend-inner-icon="mdi-email-outline"
                      outlined
                      color="primary"
                      :rules="[
                        (v) => !!v || 'E-mail é obrigatório',
                        (v) => /.+@.+\..+/.test(v) || 'E-mail deve ser válido',
                      ]"
                      type="email"
                      clearable
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.cpf"
                      label="CPF"
                      prepend-inner-icon="mdi-card-account-details-outline"
                      outlined
                      color="primary"
                      :rules="[(v) => !!v || 'CPF é obrigatório']"
                      v-mask="'###.###.###-##'"
                      clearable
                    />
                  </v-col>
                </v-row>

                <v-text-field
                  v-model="userData.password"
                  :type="showPassword ? 'text' : 'password'"
                  label="Senha (mín. 10 caracteres)"
                  prepend-inner-icon="mdi-lock-outline"
                  outlined
                  color="primary"
                  :rules="[regraDeSenhaForte]"
                  class="mb-2"
                  clearable
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="showPassword = !showPassword"
                        >
                          {{ showPassword ? "mdi-eye" : "mdi-eye-off" }}
                        </v-icon>
                      </template>
                      <span>{{
                        showPassword ? "Ocultar senha" : "Mostrar senha"
                      }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <PasswordRequirements :senha="userData.password || ''" />

                <v-row>
                  <v-col cols="12" sm="4" v-if="userType !== 'assistant'">
                    <!-- Seletor de tipo de registro -->
                    <v-select
                      v-model="userData.professional_registration_type"
                      :items="professional_registration_types"
                      label="Tipo de Registro"
                      prepend-inner-icon="mdi-card-account-details"
                      outlined
                      color="primary"
                      :rules="[(v) => !!v || 'Tipo de registro é obrigatório']"
                      class="mb-3"
                    />
                  </v-col>

                  <v-col cols="12" sm="4" v-if="userType !== 'assistant'">
                    <!-- ✅ Task 5: UF do conselho (CRM-SP, CRN-RJ, etc) -->
                    <v-select
                      v-model="userData.professional_registration_state"
                      :items="brazilianStates"
                      label="UF do Conselho"
                      prepend-inner-icon="mdi-map"
                      outlined
                      color="primary"
                      :rules="[(v) => !!v || 'UF do conselho é obrigatória']"
                      class="mb-3"
                      hint="Conselhos são estaduais. Ex: CRM-SP"
                      persistent-hint
                    />
                  </v-col>

                  <v-col cols="12" sm="4" v-if="userType !== 'assistant'">
                    <v-text-field
                      v-if="userData.professional_registration_type !== 'OUTRO'"
                      v-model="userData.professional_registration"
                      :key="
                        'reg-' +
                        (userData.professional_registration_type || 'none')
                      "
                      :label="registrationLabel"
                      prepend-inner-icon="mdi-medical-bag"
                      outlined
                      color="primary"
                      v-mask="registrationMask"
                      :placeholder="registrationPlaceholder"
                      :rules="[
                        (v) =>
                          userType === 'assistant' ||
                          !!v ||
                          `Número do registro é obrigatório`,
                      ]"
                      clearable
                    />
                    <v-text-field
                      v-else
                      v-model="userData.professional_registration"
                      :key="'reg-outro'"
                      label="Número do Registro"
                      prepend-inner-icon="mdi-medical-bag"
                      outlined
                      color="primary"
                      placeholder="Número do registro"
                      :rules="[
                        (v) => !!v || 'Número do registro é obrigatório',
                      ]"
                      clearable
                    />
                  </v-col>
                </v-row>

                <!-- ✅ Task 4: Se escolheu OUTRO, pedir descrição do conselho -->
                <v-row
                  v-if="
                    userType !== 'assistant' &&
                    userData.professional_registration_type === 'OUTRO'
                  "
                >
                  <v-col cols="12">
                    <v-text-field
                      v-model="userData.professional_registration_description"
                      label="Descrição do conselho"
                      prepend-inner-icon="mdi-card-text-outline"
                      outlined
                      color="primary"
                      :rules="[
                        (v) =>
                          userType === 'assistant' ||
                          userData.professional_registration_type !== 'OUTRO' ||
                          !!v ||
                          'Informe o nome do conselho',
                      ]"
                      placeholder="Ex: CFO (Conselho Federal de Odontologia)"
                      hint="Informe o nome ou sigla do conselho"
                      persistent-hint
                      clearable
                      maxlength="100"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="userData.gender"
                      :items="genderOptions"
                      label="Gênero"
                      prepend-inner-icon="mdi-human-male-female"
                      outlined
                      color="primary"
                      :rules="[(v) => !!v || 'Gênero é obrigatório']"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.birth_date"
                      label="Data de Nascimento"
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      color="primary"
                      :rules="[
                        (v) => !!v || 'Data de nascimento é obrigatória',
                        (v) =>
                          new Date(v) < new Date() ||
                          'Data deve ser anterior a hoje',
                        (v) =>
                          validateAge(v) || 'Você deve ter pelo menos 18 anos',
                      ]"
                      type="date"
                      :max="minBirthDate"
                      clearable
                    />
                  </v-col>
                </v-row>

                <!-- Endereço -->
                <v-divider class="my-4" />

                <div class="form-section-label mb-3">
                  <v-icon small color="primary" class="mr-2">mdi-map-marker-outline</v-icon>
                  <span>Endereço</span>
                </div>
                <v-progress-linear
                  v-if="loadingCEP"
                  indeterminate
                  color="primary"
                  class="my-4"
                ></v-progress-linear>

                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="userData.address.cep"
                      label="CEP"
                      prepend-inner-icon="mdi-map-search-outline"
                      type="text"
                      outlined
                      clearable
                      color="primary"
                      :rules="[
                        (v) => !v || /^\d{5}-?\d{3}$/.test(v) || 'CEP inválido',
                      ]"
                      maxlength="9"
                      @blur="fetchAddressByCEPUser()"
                      @click:clear="clearUserAddress"
                      v-mask="'#####-###'"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.address.street"
                      label="Logradouro"
                      prepend-inner-icon="mdi-road-variant"
                      outlined
                      clearable
                      color="primary"
                      maxlength="255"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.address.number"
                      label="Número"
                      prepend-inner-icon="mdi-numeric"
                      outlined
                      clearable
                      color="primary"
                      maxlength="10"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.address.complement"
                      label="Complemento (opcional)"
                      prepend-inner-icon="mdi-home-plus-outline"
                      outlined
                      clearable
                      color="primary"
                      maxlength="100"
                      placeholder="Ex: Apto 202, Bloco B"
                      hint="Apartamento, sala, bloco, etc."
                      persistent-hint
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.address.neighborhood"
                      label="Bairro"
                      prepend-inner-icon="mdi-home-city-outline"
                      outlined
                      clearable
                      color="primary"
                      maxlength="255"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.address.city"
                      label="Cidade"
                      prepend-inner-icon="mdi-city"
                      outlined
                      clearable
                      color="primary"
                      maxlength="255"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="userData.address.state"
                      label="Estado (UF)"
                      prepend-inner-icon="mdi-map"
                      outlined
                      clearable
                      color="primary"
                      maxlength="2"
                    />
                  </v-col>
                </v-row>

                <!-- Telefones do Usuário -->
                <v-divider class="my-4" />
                <div class="d-flex align-center justify-space-between mb-3">
                  <div class="form-section-label">
                    <v-icon small color="primary" class="mr-2">mdi-phone-outline</v-icon>
                    <span>Telefones Pessoais</span>
                  </div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-btn
                          small
                          color="primary"
                          rounded
                          @click="addUserPhone"
                          :disabled="userData.phones.length >= 3"
                          dark
                          class="add-phone-btn"
                        >
                          <v-icon small left>mdi-plus</v-icon>
                          Adicionar
                        </v-btn>
                      </div>
                    </template>
                    <span>{{
                      userData.phones.length >= 3
                        ? "Limite de 3 telefones atingido"
                        : "Adicionar um novo telefone"
                    }}</span>
                  </v-tooltip>
                </div>

                <div
                  v-for="(telefone, index) in userData.phones"
                  :key="index"
                  class="mb-3"
                >
                  <v-row>
                    <v-col cols="12" sm="5">
                      <v-text-field
                        v-model="telefone.number"
                        :label="`Telefone ${index + 1}`"
                        prepend-inner-icon="mdi-phone"
                        outlined
                        dense
                        color="primary"
                        :rules="[(v) => !!v || 'Número é obrigatório']"
                        v-mask="'(##) #####-####'"
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="telefone.type"
                        :items="phoneTypes"
                        label="Tipo"
                        outlined
                        dense
                        color="primary"
                        :rules="[(v) => !!v || 'Tipo é obrigatório']"
                      />
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-checkbox
                              v-model="telefone.is_primary"
                              label="Principal"
                              color="primary"
                              dense
                              @change="defineUserPrimaryPhone(index)"
                            />
                          </div>
                        </template>
                        <span
                          >Define este número como telefone principal para
                          contato</span
                        >
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" sm="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="removeUserPhones(index)"
                            v-if="userData.phones.length > 1"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Remover este telefone</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>

            <!-- BOTÃO DE CADASTRO -->
            <v-btn
              :disabled="!userType"
              color="primary"
              rounded
              block
              height="50"
              class="mt-6 auth-submit-btn"
              :loading="loading"
              @click="registerNewUser"
              dark
            >
              <v-icon left>mdi-account-plus</v-icon>
              Criar Conta
            </v-btn>

            <!-- ✅ Task 6: Cadastro com Google -->
            <div class="auth-divider my-5">
              <span class="auth-divider-text">Ou cadastre-se usando</span>
            </div>

            <v-btn
              rounded
              outlined
              block
              height="44"
              class="google-btn"
              :loading="googleLoading"
              @click="startGoogleSignup"
            >
              <v-icon left color="#EA4335">mdi-google</v-icon>
              Cadastrar com Google
            </v-btn>
          </div>
        </v-expand-transition>

        <!-- ERRO -->
        <div v-if="erro" class="mt-4 text-center">
          <v-alert type="error" text dense rounded class="register-alert">
            <v-icon small class="mr-1">mdi-alert-circle</v-icon>
            {{ erro }}
          </v-alert>
        </div>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import PasswordRequirements from "@/components/shared/PasswordRequirements.vue";
import { regraDeSenhaForte } from "@/utils/politicaDeSenha";
import axios from "axios";
import http from "@/services/http";
import { useSnackbar } from "@/composables/useSnackbar";
import { toDateISO } from "@/utils/datetime";
import { calculateAge } from "@/utils/calculateAge.js";
const { success, error, warning, info, showSnackbar } = useSnackbar();

export default {
  name: "RegisterPage",
  components: { PasswordRequirements },
  emits: ["voltar"],

  data() {
    return {
      formValido: false,
      loading: false,
      googleLoading: false, // ✅ Task 6
      showPassword: false,
      userType: null,
      erro: "",

      userData: {
        name: "",
        email: "",
        password: "",
        cpf: "",
        professional_registration_type: "CRM", // tipo de registro
        professional_registration_state: "", // ✅ Task 5: UF do conselho
        professional_registration_description: "", // ✅ Task 4: descrição quando for "OUTRO"
        professional_registration: "", // número
        gender: "",
        birth_date: "",
        status: true, // Status padrão ativo
        role_id: 1,
        phones: [{ number: "", type: "celular", is_primary: true }],
        address: {
          cep: "",
          street: "",
          number: "",
          complement: "", // ✅ Task 1
          neighborhood: "",
          city: "",
          state: "",
        },
      },

      professional_registration_types: [
        { text: "CRM (Medicina)", value: "CRM" },
        { text: "CRN (Nutrição)", value: "CRN" },
        { text: "CRF (Farmácia)", value: "CRF" },
        { text: "CREFITO (Fisioterapia)", value: "CREFITO" },
        { text: "CRP (Psicologia)", value: "CRP" },
        { text: "COREN (Enfermagem)", value: "COREN" },
        { text: "CRMV (Medicina Veterinária)", value: "CRMV" },
        { text: "Outro", value: "OUTRO" }, // ✅ Task 4
      ],

      // ✅ Task 5: UFs brasileiras
      brazilianStates: [
        "AC",
        "AL",
        "AM",
        "AP",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MG",
        "MS",
        "MT",
        "PA",
        "PB",
        "PE",
        "PI",
        "PR",
        "RJ",
        "RN",
        "RO",
        "RR",
        "RS",
        "SC",
        "SE",
        "SP",
        "TO",
      ],

      phoneTypes: [
        { text: "Celular", value: "celular" },
        { text: "Fixo", value: "fixo" },
      ],

      genderOptions: [
        { text: "Masculino", value: "Masculino" },
        { text: "Feminino", value: "Feminino" },
        { text: "Outro", value: "Outro" },
      ],

      loadingCEP: false,
    };
  },

  watch: {
    userType(novoTipo) {
      if (novoTipo === "assistant") {
        this.userData.role_id = 3; // ID 3 para assistente
        this.userData.professional_registration_type = "";
        this.userData.professional_registration = "";
        this.userData.professional_registration_state = ""; // ✅ Task 5
        this.userData.professional_registration_description = ""; // ✅ Task 4
      } else {
        this.userData.role_id = 1; // ID 1 para profissional
        this.userData.professional_registration_type = "CRM"; // padrão
        this.userData.professional_registration = ""; // 🔥 resetar o número também
        this.userData.professional_registration_state = ""; // ✅ Task 5
        this.userData.professional_registration_description = ""; // ✅ Task 4
      }
    },

    "userData.professional_registration_type"(newType, oldType) {
      if (!oldType) return;
      if (newType !== oldType) {
        this.userData.professional_registration = "";
        // Se saiu de OUTRO ou veio pra OUTRO, limpa a descrição também
        if (newType === "OUTRO" || oldType === "OUTRO") {
          this.userData.professional_registration_description = "";
        }
      }
    },
  },

  computed: {
    registrationMask() {
      const t = (
        this.userData.professional_registration_type || ""
      ).toUpperCase();
      // ✅ Task 5: Máscaras sem UF embutida — UF agora é campo separado
      if (t === "CRM") return "######";
      if (t === "CRP") return "##/######";
      if (t === "COREN") return "######";
      if (t === "CRN") return "######";
      if (t === "CRF") return "######";
      if (t === "CREFITO") return "######-A";
      if (t === "CRMV") return "######";
      if (t === "OUTRO") return ""; // sem máscara pra "outro"
      return "######";
    },

    registrationLabel() {
      const t = (
        this.userData.professional_registration_type || ""
      ).toUpperCase();
      if (t === "OUTRO") return "Número do Registro"; // ✅ Task 4
      const map = {
        CRM: "Número do CRM",
        CRN: "Número do CRN",
        CRF: "Número do CRF",
        CREFITO: "Número do CREFITO",
        CRP: "Número do CRP",
        COREN: "Número do COREN",
        CRMV: "Número do CRMV",
      };
      return map[t] || "Número do Registro";
    },

    registrationPlaceholder() {
      const t = (
        this.userData.professional_registration_type || ""
      ).toUpperCase();
      if (t === "CRM") return "Ex: 12345";
      if (t === "CRP") return "Ex: 06/123456";
      if (t === "COREN") return "Ex: 123456";
      if (t === "CRN") return "Ex: 123456";
      if (t === "CRF") return "Ex: 123456";
      if (t === "CREFITO") return "Ex: 123456-F";
      if (t === "CRMV") return "Ex: 12345";
      if (t === "OUTRO") return "Número do registro";
      return "Ex: 123456";
    },

    // 🆕 NOVO: Calcula idade mínima permitida (18 anos atrás)
    minBirthDate() {
      const hoje = new Date();
      const ano18AnosAtras = hoje.getFullYear() - 18;
      return toDateISO(
        new Date(ano18AnosAtras, hoje.getMonth(), hoje.getDate()),
      );
    },
  },

  methods: {
    regraDeSenhaForte,
    // Valida maioridade usando a implementação única (imune a fuso).
    validateAge(birthDate) {
      const age = calculateAge(birthDate);
      return Number.isFinite(age) && age >= 18;
    },
    // 🆕 NOVO: Valida se a pessoa tem 18 anos ou mais

    backToLoginPage() {
      this.$emit("voltar");
    },

    // Gerenciamento de telefones do usuário
    addUserPhone() {
      if (this.userData.phones.length < 3) {
        this.userData.phones.push({
          number: "",
          type: "celular",
          is_primary: false,
        });
      }
    },

    removeUserPhones(index) {
      if (this.userData.phones.length > 1) {
        this.userData.phones.splice(index, 1);
        // Se removeu o primário, define o primeiro como primário
        if (!this.userData.phones.some((phone) => phone.is_primary)) {
          this.userData.phones[0].is_primary = true;
        }
      }
    },

    defineUserPrimaryPhone(index) {
      this.userData.phones.forEach((phone, i) => {
        phone.is_primary = i === index;
      });
    },

    // Limpar endereço
    clearUserAddress() {
      this.userData.address = {
        cep: "",
        street: "",
        number: "",
        complement: "", // ✅ Task 1
        neighborhood: "",
        city: "",
        state: "",
      };
    },

    // Preparar dados para envio
    prepareDataForBackend() {
      const dados = { ...this.userData };

      // Filtrar telefones vazios
      dados.phones = this.userData.phones.filter(
        (phone) => phone.number && phone.number.trim(),
      );

      // Se não tiver telefones, enviar array vazio (nullable no backend)
      if (dados.phones.length === 0) {
        dados.phones = null;
      }

      // ✅ Tasks 4 e 5: tratamento dos campos do registro profissional
      if (this.userType === "assistant") {
        // Assistente não tem registro profissional
        delete dados.professional_registration;
        delete dados.professional_registration_type;
        delete dados.professional_registration_state;
        delete dados.professional_registration_description;
      } else {
        // Se for "OUTRO", o tipo enviado ao backend é a descrição informada
        // (ex: "CFO" no lugar de "OUTRO"), o que mantém um registro semântico real.
        if (dados.professional_registration_type === "OUTRO") {
          const descricao = (
            dados.professional_registration_description || ""
          ).trim();
          dados.professional_registration_type = descricao || "OUTRO";
        }
        // Limpa o campo auxiliar — backend não precisa dele
        delete dados.professional_registration_description;
      }

      return dados;
    },

    // Submissão do formulário
    async registerNewUser() {
      if (!this.$refs.form.validate()) {
        warning("Por favor, corrija os campos obrigatórios");
        return;
      }

      // Validar se há pelo menos um telefone preenchido
      const telefonesValidos = this.userData.phones.filter(
        (phone) => phone.number && phone.number.trim(),
      );

      if (telefonesValidos.length === 0) {
        warning("Adicione pelo menos um telefone");
        return;
      }

      this.loading = true;
      this.erro = "";

      try {
        const dadosEnvio = this.prepareDataForBackend();
        // SALVIA-744: pelo `http`, que busca o cookie de CSRF antes do POST.
        // Com o axios cru a API responderia 419 (o front é origem "stateful"
        // do Sanctum, e POST de lá exige o token CSRF).
        const response = await http.post("/api/user/create-user", dadosEnvio);

        if (response.data.status === "success") {
          this.resetForm();
          success(response.data.message || "Usuário cadastrado com sucesso!");

          setTimeout(() => {
            this.backToLoginPage();
          }, 2000);
        }
      } catch (err) {
        console.error("Erro no registro:", err);

        if (err.response?.status === 422) {
          // ✅ Task 3: usa primeiro o errors.<campo> (mais específico),
          // e depois cai no message (que o backend já formata bem).
          const errors = err.response.data?.errors;
          const backendMessage = err.response.data?.message;

          if (errors && Object.keys(errors).length > 0) {
            const firstError = Object.values(errors)[0];
            this.erro = Array.isArray(firstError) ? firstError[0] : firstError;
          } else if (backendMessage) {
            this.erro = backendMessage;
          } else {
            this.erro = "Verifique os dados informados.";
          }
          error(this.erro);
        } else if (err.response?.status === 500) {
          this.erro = "Erro interno do servidor. Tente novamente.";
          error("Erro interno do servidor");
        } else {
          const msg = err?.response?.data?.message || "Erro ao criar conta.";
          this.erro = msg;
          error(msg);
        }
      } finally {
        this.loading = false;
      }
    },

    // ✅ Task 6: Cadastro com Google
    // Reusa exatamente o mesmo endpoint do LoginPage - o callback do backend
    // detecta se é usuário novo e redireciona para a tela de seleção de role.
    async startGoogleSignup() {
      this.googleLoading = true;
      this.erro = "";

      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/auth/google/login/redirect`,
        );

        window.location.href = data.redirect_url;
      } catch (err) {
        console.error("Erro ao iniciar cadastro com Google:", err);
        const msg =
          err.response?.data?.message ||
          "Não foi possível iniciar o cadastro com Google. Tente novamente.";
        this.erro = msg;
        error(msg);
      } finally {
        this.googleLoading = false;
      }
    },

    // Resetar os campos do formulário
    resetForm() {
      this.userData = {
        name: "",
        email: "",
        password: "",
        cpf: "",
        professional_registration_type: "CRM",
        professional_registration_state: "", // ✅ Task 5
        professional_registration_description: "", // ✅ Task 4
        professional_registration: "",
        gender: "",
        birth_date: "",
        status: true,
        role_id: 1,
        address: {
          cep: "",
          street: "",
          number: "",
          complement: "", // ✅ Task 1
          neighborhood: "",
          city: "",
          state: "",
        },
        phones: [{ number: "", type: "celular", is_primary: true }],
      };

      this.userType = "doctor";
      this.erro = "";
      this.loading = false;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    async fetchAddressByCEPUser() {
      const cep = this.userData.address.cep?.replace(/\D/g, "");
      if (!cep || cep.length !== 8) return;

      try {
        this.loadingCEP = true;
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        const data = await response.json();

        if (data.erro) {
          warning("CEP não encontrado.");
          return;
        }

        this.userData.address.street = data.logradouro || "";
        this.userData.address.neighborhood = data.bairro || "";
        this.userData.address.city = data.localidade || "";
        this.userData.address.state = data.uf || "";
      } catch (err) {
        // A variável do catch se chamava `error` e escondia o helper `error()`
        // do useSnackbar, importado no topo do arquivo. Em vez do aviso, a
        // linha abaixo tentava chamar o objeto de erro como função e lançava
        // TypeError — ou seja, falhar o CEP quebrava o formulário em silêncio.
        console.error("Erro ao buscar CEP:", err);
        error("Erro ao buscar o CEP.");
      } finally {
        this.loadingCEP = false;
      }
    },
  },
};
</script>

<style scoped>
/* ═══ Layout ═══ */
.fill-height {
  height: 100vh;
}

.register-content {
  background: var(--ds-surface-white);
}

/* ═══ Side panel (espelha o LoginPage) ═══ */
.auth-side-panel {
  background: linear-gradient(135deg, var(--ds-primary) 0%, var(--ds-primary-dark) 60%, var(--ds-primary-darker) 100%);
  position: relative;
  overflow: hidden;
}

.auth-side-panel::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: radial-gradient(ellipse at center, black 30%, transparent 75%);
  -webkit-mask-image: radial-gradient(ellipse at center, black 30%, transparent 75%);
  pointer-events: none;
}

.signup-overlay {
  z-index: 1;
  position: relative;
}

.logo-avatar {
  background: var(--ds-surface-white) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18) !important;
  border: 4px solid rgba(255, 255, 255, 0.15);
}

.brand-title {
  font-size: 32px;
  font-weight: 800;
  color: var(--ds-white);
  letter-spacing: -0.8px;
}

.side-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  max-width: 320px;
  margin: 0 auto;
}

.side-cta {
  font-size: 13px !important;
  font-weight: 700 !important;
  letter-spacing: 0.4px !important;
  border: 2px solid rgba(255, 255, 255, 0.4) !important;
  height: 46px !important;
}

.side-cta:hover {
  background: rgba(255, 255, 255, 0.12) !important;
  border-color: var(--ds-white) !important;
}

/* ═══ Section header pattern ═══ */
.auth-section-header {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
}

.auth-section-title {
  font-size: 11px;
  font-weight: 700;
  color: var(--ds-primary);
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.auth-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--ds-text-strong);
  letter-spacing: -0.5px;
}

.auth-subtitle {
  font-size: 14px;
  color: var(--ds-text-soft);
  font-weight: 500;
  margin: 0;
}

/* ═══ Cards do formulário ═══ */
.register-card {
  border-radius: 12px !important;
  border: 1.5px solid var(--ds-blue-100) !important;
  box-shadow: 0 2px 8px rgba(31, 77, 63, 0.04) !important;
}

.register-card-title {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--ds-primary) !important;
  letter-spacing: 0.3px;
  padding: 14px 20px !important;
  background: var(--ds-blue-50);
}

.register-alert {
  border-radius: 10px !important;
  font-size: 12px !important;
}

/* ═══ Sub-section labels ═══ */
.form-section-label {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--ds-primary);
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

/* ═══ Botões ═══ */
.add-phone-btn {
  font-size: 11px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  text-transform: none !important;
  box-shadow: 0 2px 6px rgba(31, 77, 63, 0.18) !important;
}

.auth-submit-btn {
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: 0.3px !important;
  text-transform: none !important;
  color: var(--ds-white) !important;
  box-shadow: 0 6px 16px rgba(31, 77, 63, 0.28) !important;
}

.auth-divider {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-divider::before,
.auth-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--ds-gray-300);
}

.auth-divider-text {
  font-size: 11px;
  font-weight: 600;
  color: var(--ds-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding: 0 16px;
}

.google-btn {
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px !important;
  text-transform: none !important;
  border: 1.5px solid var(--ds-gray-300) !important;
  color: var(--ds-text-600) !important;
}

.google-btn:hover {
  border-color: var(--ds-primary) !important;
  box-shadow: 0 4px 12px rgba(31, 77, 63, 0.1) !important;
}

@media (max-width: 960px) {
  .fill-height {
    height: auto;
    min-height: 100vh;
  }
}
</style>
